/**
 * Mimics  {@link https://vue-i18n.intlify.dev/api/composition.html#usei18n | `useI18n`} of {@link https://github.com/intlify/vue-i18n | @intlify/vue-i18n}.
 *
 * @todo Remove this composable after final transition to {@link https://github.com/intlify/vue-i18n | @intlify/vue-i18n}.
 */
export function useI18n() {
  return useNuxtApp().$i18n
}
